module.exports = __webpack_public_path__ + "static/img/logo.d858796.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/logo.png
// module id = /dB8
// module chunks = 1